import React from 'react';
import FormatButton from './FormatButton';

import CodeEditorContext from '../CodeEditorContext';

function ConnectedFormatButton({
  accentColor,
}: {
  accentColor: string;
}) {
  const { formatCodeWithOffset } =
    React.useContext(CodeEditorContext);

  return (
    <FormatButton
      accentColor={accentColor}
      handleFormat={formatCodeWithOffset}
    />
  );
}

export default ConnectedFormatButton;
